export default __webpack_public_path__ + "static/pads-product-f75987cd744f66ce76029a90e2e6277e.png";